// extracted by mini-css-extract-plugin
export default {"banner":"LeftBar_banner__zpLmL","bannerHead":"LeftBar_bannerHead__e90E-"};